import React from 'react';

function Twinkle(props) {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M5.90361 2.0708L6.39732 5.43577C6.60166 7.0929 7.82922 8.43978 9.45949 8.79775L11.8072 9.31383L9.45949 9.82991C7.82922 10.1879 6.60166 11.5348 6.39732 13.1919L5.90361 17.1863L5.4099 13.1919C5.20556 11.5348 3.978 10.1879 2.34772 9.82991L0 9.31383L2.34772 8.79775C3.978 8.43978 5.20556 7.0929 5.4099 5.43577L5.90361 2.0708Z"
        fill="#FFD56B"
      />
      <path
        d="M12.9408 2.742L13.1959 4.53785C13.3018 5.49543 13.9387 6.27403 14.7829 6.48135L16 6.77967L14.7829 7.07798C13.9387 7.28531 13.3018 8.0639 13.1959 9.02149L12.9408 11.3304L12.6858 9.01999C12.5799 8.06241 11.943 7.28381 11.0988 7.07649L9.88165 6.77817L11.0988 6.47986C11.943 6.27253 12.5799 5.49394 12.6858 4.53636L12.9408 2.742Z"
        fill="#FFD56B"
      />
      <path
        d="M11.5223 12.4118L11.2061 10.4847L10.8899 12.4118C10.7587 13.4708 9.97261 14.3329 8.93001 14.5626L7.42651 14.8923L8.93001 15.2219C9.9741 15.4501 10.7587 16.3122 10.8899 17.3727L11.2061 19.9293L11.5223 17.3727C11.6536 16.3137 12.4397 15.4516 13.4823 15.2219L14.9858 14.8923L13.4823 14.5626C12.4382 14.3344 11.6536 13.4723 11.5223 12.4118Z"
        fill="#FFD56B"
      />
    </svg>
  );
}

export default Twinkle;
